import React from 'react';
import { DiabetesPageTemplate } from './DiabetesPageTemplate';
import { diabetesImages } from './diabetesPageData';

const WhatIsDiabetes = () => {
  return (
    <DiabetesPageTemplate
      eyebrow="Diabetes Basics"
      title="What Is Diabetes?"
      intro="Diabetes is a disorder, not a disease. It is a metabolic condition with serious health consequences, but one that can often be managed with timely diagnosis, informed choices, and steady medical care."
      heroSummary="Understanding insulin, glucose, and the different forms of diabetes makes the condition much easier to manage."
      heroImage={diabetesImages.whatIsImg}
      heroAlt="Illustration explaining what diabetes is"
      sections={[
        {
          title: 'Introduction',
          paragraphs: [
            "Diabetes is a disorder, not a disease - this is something that we reinforce repeatedly. Unfortunately, that does not make it any less dangerous to our health or lives. It's a metabolic disorder, yes, but its consequences are life threatening. A 2014 study estimates that about 62 million people in India are diabetics and the number is projected to rise to 79.4 million by 2030. However, there is respite in the fact that it's a condition that's very much in our control to regularize. Before getting to the causes of diabetes or symptoms, let's first gather some understanding and information about diabetes to comprehend its implications better.",
          ],
          image: diabetesImages.whatIsSupport,
          imageAlt: 'Visual representation of blood sugar and insulin balance',
          imageCaption: 'The condition becomes easier to understand once glucose movement and insulin function are clear.',
        },
        {
          title: 'What Is Diabetes Mellitus?',
          paragraphs: [
            'Our body cells require glucose to function. This is either obtained from the metabolism of food or is produced by the liver and delivered through blood. Insulin is the hormone secreted by the pancreas that allows our cells to absorb glucose. This gives us energy for all voluntary activities like working, playing, exercising, walking or even reading, and involuntary activities such as heart functioning, digestion, among others.',
            "In diabetes, the glucose doesn't make it to the cells, thus making them starve for energy. This can be due to very low levels of insulin in the blood or reduced ability of the body to use insulin.",
            'Constantly elevated levels of blood sugar cause serious complications such as heart attacks, foot disease, kidney disease, eye disease and others.',
            'When speaking of what is diabetes, we must understand that there are 4 types of diabetes, each having their own course of management. We can successfully manage diabetes only after gathering all the information about diabetes.',
          ],
        },
      ]}
    />
  );
};

export default WhatIsDiabetes;
